var map = {
	"./MarkAsRead.png": "6f31",
	"./apple.png": "3c8f",
	"./briefcase.png": "ce2d",
	"./calendar.png": "6959",
	"./google.png": "87f7",
	"./ieNotice.png": "3819",
	"./invoices.png": "f168",
	"./microsoft-office.png": "2df3",
	"./microsoft-outlook.png": "d5fa",
	"./myjourney.png": "77fe",
	"./notificationAssessments.png": "24f1",
	"./notificationCalendar.png": "efe8",
	"./notificationGeneral.png": "3479",
	"./swipeArrow.png": "5677",
	"./teams.png": "cd33"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8cba";